"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootshopTransactionHistoryItemToJSON = exports.LootshopTransactionHistoryItemFromJSONTyped = exports.LootshopTransactionHistoryItemFromJSON = void 0;
var runtime_1 = require("../runtime");
function LootshopTransactionHistoryItemFromJSON(json) {
    return LootshopTransactionHistoryItemFromJSONTyped(json, false);
}
exports.LootshopTransactionHistoryItemFromJSON = LootshopTransactionHistoryItemFromJSON;
function LootshopTransactionHistoryItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : json['amount'],
        'amountFormatted': !(0, runtime_1.exists)(json, 'amountFormatted') ? undefined : json['amountFormatted'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'itemCount': !(0, runtime_1.exists)(json, 'itemCount') ? undefined : json['itemCount'],
        'paymentMethod': !(0, runtime_1.exists)(json, 'paymentMethod') ? undefined : json['paymentMethod'],
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
    };
}
exports.LootshopTransactionHistoryItemFromJSONTyped = LootshopTransactionHistoryItemFromJSONTyped;
function LootshopTransactionHistoryItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'amount': value.amount,
        'amountFormatted': value.amountFormatted,
        'description': value.description,
        'itemCount': value.itemCount,
        'paymentMethod': value.paymentMethod,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
    };
}
exports.LootshopTransactionHistoryItemToJSON = LootshopTransactionHistoryItemToJSON;
